/*
 * @Author: 吴文洁
 * @LastEditors: 吴文洁
 * @Description: 
 * @Date: 2019-05-11 16:51:32
 * @LastEditTime: 2019-06-21 14:36:57
 */
import { Vue } from "vue-property-decorator";
export interface Rule {
  condition: string,       // 规则的唯一标识符号
  errMsg: string,          // 校验不通过时的提示信息
  min?: number,            // 区间最小值
  max?: number,            // 区间最大值
  limit?: number,          // 边界情况
  regExp?:any,          // 正则表达式
}

export default class Validate{
  validateList: Array<Function>;
  validateCondition: { [index: string] : Function};
  constructor(validateCondition: { [index: string] : Function}) {
    this.validateList = [];
    this.validateCondition = validateCondition;
  }

  // 添加校验，需要校验的值和检验规则
  add(value: string | number, rules: Rule[]) {
    rules.forEach((rule: Rule) => {
      const { condition, errMsg, min, max, limit, regExp } = rule;

      this.validateList.push(() => {
        return this.validateCondition[condition].apply(this, [value, errMsg, min, max, limit, regExp]);
      });
    });
  }
  // 校验结果
  result() {
    const len = this.validateList.length;
    for (let i = 0; i < len; i++) {
      const validate = this.validateList[i];
      const errMsg = validate();
      if (errMsg) return errMsg;
    }
  }
}